import segment from 'src/js/modules/analytics/segment';

const trackImageResizingCompleted = ({
  blockId,
  blockVariationId,
  oldHeight,
  newHeight,
  affectedImages,
  shiftKeyPressed,
  compositeGroup,
  elementId,
}) => {
  const {
    trackers: { trackEvent },
    constants,
  } = segment;

  trackEvent(constants.events.IMAGE_RESIZING_COMPLETED, {
    elementId,
    blockId,
    blockVariationId,
    oldHeight,
    newHeight,
    affectedImages,
    shiftKeyPressed,
    compositeGroup,
  });
};

export default trackImageResizingCompleted;
